import {Action} from "@ngrx/store";

export class Logout implements Action {
  readonly type = ActionTypes.LOGOUT;
}

export enum ActionTypes {
  LOGOUT = "[App] logout"
}
